/* cb-chat.js — Clever Guide, KI-Assistent und Bikefinder (Chatfenster).
   Server: ~/cleverbikes/bikefinder-chat (Cloudflare Worker), Adresse aus data-endpoint (snippets/cb-chat.liquid).
   Verlauf liegt in der sessionStorage; der Server protokolliert Gespräche 180 Tage (Datenschutz 9.3). Smiley-Bewertung ab 2 Antworten. */
(function () {
  'use strict';
  var wurzel = document.getElementById('cb-chat');
  if (!wurzel || wurzel.dataset.bereit) return;
  wurzel.dataset.bereit = '1';

  var ENDPOINT = (wurzel.dataset.endpoint || '').replace(/\/$/, '');
  var SPEICHER = 'cb-chat-v1';
  var MAX_VERLAUF = 30;
  var seite = wurzel.dataset.handle ? { handle: wurzel.dataset.handle, titel: wurzel.dataset.titel || '' } : null;

  var BEGRUESSUNG = 'Hallo! Ich bin **Clever Guide**, der KI-Assistent von Cleverbikes. Erzähl mir, wofür du ein Rad suchst, dann zeige ich dir passende Räder aus unserem aktuellen Bestand.';
  var CHIPS = ['E-Bike für den Arbeitsweg', 'E-Mountainbike', 'Fahrrad ohne Motor', 'Versand & Garantie'];

  var zustand = lade() || { offen: false, verlauf: [] };
  // Zufällige Gesprächs-ID ohne Personenbezug (für das Chat-Protokoll, siehe Datenschutzerklärung 9.3)
  function neueId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx'.replace(/x/g, function () { return (Math.random() * 16 | 0).toString(16); });
  }
  if (!zustand.id) zustand.id = neueId();
  var laeuft = false;

  // ── Speicher (kann in privaten Fenstern fehlen) ──
  function lade() {
    try { return JSON.parse(sessionStorage.getItem(SPEICHER) || 'null'); } catch (e) { return null; }
  }
  function speichere() {
    try {
      zustand.verlauf = zustand.verlauf.slice(-MAX_VERLAUF);
      sessionStorage.setItem(SPEICHER, JSON.stringify(zustand));
    } catch (e) { /* egal */ }
  }

  // ── Hilfen ──
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Minimales Markdown: **fett**, Listen mit "- ", Absätze, Links (nur http/https)
  function formatiere(text) {
    var bloecke = esc(text || '').split(/\n{2,}/);
    return bloecke.map(function (b) {
      var zeilen = b.split('\n');
      var istListe = zeilen.every(function (z) { return /^\s*[-•]\s+/.test(z) || !z.trim(); });
      var inline = function (s) {
        return s
          .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
          .replace(/(https?:\/\/[^\s<)]+[^\s<).,;:!?])/g, '<a href="$1" target="_blank" rel="noopener">$1</a>');
      };
      if (istListe) {
        return '<ul>' + zeilen.filter(function (z) { return z.trim(); }).map(function (z) {
          return '<li>' + inline(z.replace(/^\s*[-•]\s+/, '')) + '</li>';
        }).join('') + '</ul>';
      }
      return '<p>' + inline(zeilen.join('<br>')) + '</p>';
    }).join('');
  }
  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  function preis(cent) { return euro.format(cent / 100); }
  function km(n) { return n == null ? null : n.toLocaleString('de-DE') + ' km'; }

  var ICON = {
    funkeln: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M10 2.5c.4 3.9 3.6 7.1 7.5 7.5-3.9.4-7.1 3.6-7.5 7.5-.4-3.9-3.6-7.1-7.5-7.5 3.9-.4 7.1-3.6 7.5-7.5z"/><path d="M18.5 13.5c.2 2 1.8 3.6 3.8 3.8-2 .2-3.6 1.8-3.8 3.8-.2-2-1.8-3.6-3.8-3.8 2-.2 3.6-1.8 3.8-3.8z"/></svg>',
    zu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    neu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>',
    mikro: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>',
    senden: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>'
  };

  // ── Aufbau ──
  wurzel.className = 'cbchat';
  wurzel.innerHTML =
    '<button type="button" class="cbchat__start" aria-haspopup="dialog" aria-expanded="false">' + ICON.funkeln + '<span>Clever Guide</span></button>' +
    '<div class="cbchat__fenster" role="dialog" aria-modal="false" aria-labelledby="cbchat-titel">' +
      '<div class="cbchat__kopf">' +
        '<div class="cbchat__kopf-text"><p class="cbchat__titel" id="cbchat-titel">Clever Guide</p><p class="cbchat__untertitel"><b>KI-Assistent</b> von Cleverbikes</p></div>' +
        '<button type="button" class="cbchat__knopf" data-aktion="neu" aria-label="Neues Gespräch" title="Neues Gespräch">' + ICON.neu + '</button>' +
        '<button type="button" class="cbchat__knopf" data-aktion="zu" aria-label="Chat schließen" title="Schließen">' + ICON.zu + '</button>' +
      '</div>' +
      '<div class="cbchat__verlauf" aria-live="polite"></div>' +
      '<div class="cbchat__fuss">' +
        '<form class="cbchat__form">' +
          '<label class="cbchat__sr" for="cbchat-eingabe">Deine Nachricht</label>' +
          '<textarea id="cbchat-eingabe" class="cbchat__eingabe" rows="1" maxlength="1500" placeholder="Wonach suchst du?"></textarea>' +
          '<button type="button" class="cbchat__mikro" aria-label="Spracheingabe starten" title="Spracheingabe" hidden>' + ICON.mikro + '</button>' +
          '<button type="submit" class="cbchat__senden" aria-label="Senden" disabled>' + ICON.senden + '</button>' +
        '</form>' +
        '<p class="cbchat__hinweis">KI-Antworten können Fehler enthalten. Verbindlich sind die Angaben auf der Produktseite. Gespräche speichern wir 180 Tage, um den Chat zu verbessern. Bitte gib keine persönlichen Daten ein. <a href="/policies/privacy-policy">Datenschutz</a></p>' +
      '</div>' +
    '</div>';
  document.body.classList.add('cbchat-an');

  var start = wurzel.querySelector('.cbchat__start');
  var verlaufEl = wurzel.querySelector('.cbchat__verlauf');
  var form = wurzel.querySelector('.cbchat__form');
  var eingabe = wurzel.querySelector('.cbchat__eingabe');
  var sendenBtn = wurzel.querySelector('.cbchat__senden');
  var mikroBtn = wurzel.querySelector('.cbchat__mikro');

  // ── Darstellung ──
  function nachUnten() { verlaufEl.scrollTop = verlaufEl.scrollHeight; }

  function karteEl(k) {
    var karte = el('div', 'cbchat__karte');
    var link = el('a', 'cbchat__bild');
    link.href = k.url;
    link.setAttribute('aria-label', k.titel);
    if (k.bild) {
      var img = el('img');
      img.src = k.bild; img.alt = ''; img.loading = 'lazy'; img.width = 480; img.height = 360;
      link.appendChild(img);
    }
    if (k.uvp && k.uvp > k.preis) {
      link.appendChild(el('span', 'cbchat__badge', '−' + Math.round((1 - k.preis / k.uvp) * 100) + ' %'));
    }
    karte.appendChild(link);
    var text = el('div', 'cbchat__karte-text');
    var titel = el('a', 'cbchat__karte-titel', k.titel);
    titel.href = k.url;
    titel.style.color = 'inherit'; titel.style.textDecoration = 'none';
    text.appendChild(titel);
    var p = el('div', 'cbchat__preis', preis(k.preis));
    if (k.uvp && k.uvp > k.preis) p.appendChild(el('span', 'cbchat__uvp', preis(k.uvp)));
    text.appendChild(p);
    var daten = [
      [k.ez ? 'EZ ' + k.ez : null, km(k.km)].filter(Boolean).join(' · '),
      k.groesse ? 'Für ' + k.groesse : null,
      k.standort ? 'Standort: ' + k.standort : null
    ].filter(Boolean);
    var d = el('p', 'cbchat__daten');
    daten.forEach(function (z, i) { if (i) d.appendChild(el('br')); d.appendChild(document.createTextNode(z)); });
    text.appendChild(d);
    var mehr = el('button', 'cbchat__mehr', 'Mehr dazu');
    mehr.type = 'button';
    mehr.addEventListener('click', function () { sende('Erzähl mir mehr über das ' + k.titel + ' (ID ' + k.id + ').'); });
    text.appendChild(mehr);
    karte.appendChild(text);
    return karte;
  }

  function karteListe(karten) {
    var box = el('div', 'cbchat__karten');
    box.setAttribute('role', 'list');
    karten.forEach(function (k) { var c = karteEl(k); c.setAttribute('role', 'listitem'); box.appendChild(c); });
    return box;
  }

  function textEl(text, fehler) {
    var m = el('div', 'cbchat__msg cbchat__msg--bot' + (fehler ? ' cbchat__msg--fehler' : ''));
    m.innerHTML = formatiere(text);
    return m;
  }

  // Eine Bot-Antwort besteht aus Teilen in Reihenfolge: Text, Karten, Text …
  function botNachricht(eintrag) {
    var frag = document.createDocumentFragment();
    (eintrag.teile || [{ text: eintrag.text, fehler: eintrag.fehler }]).forEach(function (t) {
      if (t.karten && t.karten.length) frag.appendChild(karteListe(t.karten));
      else if (t.text && t.text.trim()) frag.appendChild(textEl(t.text, t.fehler));
    });
    return frag;
  }

  function zeichneAlles() {
    verlaufEl.innerHTML = '';
    var gruss = el('div', 'cbchat__msg cbchat__msg--bot');
    gruss.innerHTML = formatiere(BEGRUESSUNG);
    verlaufEl.appendChild(gruss);
    if (!zustand.verlauf.length) {
      var chips = el('div', 'cbchat__chips');
      CHIPS.forEach(function (c) {
        var b = el('button', 'cbchat__chip', c);
        b.type = 'button';
        b.addEventListener('click', function () { sende(c); });
        chips.appendChild(b);
      });
      verlaufEl.appendChild(chips);
    }
    zustand.verlauf.forEach(function (e) {
      if (e.rolle === 'user') verlaufEl.appendChild(el('div', 'cbchat__msg cbchat__msg--user', e.text));
      else verlaufEl.appendChild(botNachricht(e));
    });
    zeigeBewertung();
    nachUnten();
  }

  // ── Smiley-Bewertung am Ende (ab 2 Antworten, einmal je Gespräch; Auswertung: bikefinder-chat/scripts/bewertungen-auswertung.py) ──
  var SMILEYS = [{ wert: 3, zeichen: '🙂', text: 'Ja, hat geholfen' }, { wert: 2, zeichen: '😐', text: 'Geht so' }, { wert: 1, zeichen: '🙁', text: 'Nein, nicht geholfen' }];
  function antwortZahl() {
    return zustand.verlauf.filter(function (e) { return e.rolle === 'assistant'; }).length;
  }
  function sendeBewertung(daten) {
    try {
      fetch(ENDPOINT + '/chat/bewertung', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ gespraech: zustand.id, antworten: antwortZahl() }, daten)),
        keepalive: true
      }).catch(function () { /* Bewertung ist freiwillig, Fehler egal */ });
    } catch (e) { /* egal */ }
  }
  function zeigeBewertung() {
    var alt = verlaufEl.querySelector('.cbchat__bewertung');
    if (alt) alt.remove();
    if (laeuft || antwortZahl() < 2) return;
    var box = el('div', 'cbchat__bewertung');
    if (!zustand.bewertung) {
      box.appendChild(el('p', 'cbchat__bewertung-frage', 'Hat dir der Clever Guide geholfen?'));
      var reihe = el('div', 'cbchat__smileys');
      SMILEYS.forEach(function (s) {
        var b = el('button', 'cbchat__smiley', s.zeichen);
        b.type = 'button';
        b.setAttribute('aria-label', s.text);
        b.title = s.text;
        b.addEventListener('click', function () {
          zustand.bewertung = s.wert;
          speichere();
          sendeBewertung({ wert: s.wert });
          zeigeBewertung();
          nachUnten();
        });
        reihe.appendChild(b);
      });
      box.appendChild(reihe);
    } else if (zustand.bewertung === 1 && !zustand.kommentiert) {
      box.appendChild(el('p', 'cbchat__bewertung-frage', 'Danke! Was hat gefehlt? (freiwillig)'));
      var feld = el('textarea', 'cbchat__bewertung-feld');
      feld.rows = 2;
      feld.maxLength = 500;
      feld.setAttribute('aria-label', 'Was hat gefehlt?');
      var ok = el('button', 'cbchat__chip', 'Absenden');
      ok.type = 'button';
      ok.addEventListener('click', function () {
        var t = feld.value.trim();
        if (t) sendeBewertung({ wert: 1, kommentar: t });
        zustand.kommentiert = true;
        speichere();
        zeigeBewertung();
      });
      box.appendChild(feld);
      box.appendChild(ok);
    } else {
      box.appendChild(el('p', 'cbchat__bewertung-danke', 'Danke für dein Feedback!'));
    }
    verlaufEl.appendChild(box);
  }

  // ── Öffnen / Schließen ──
  function oeffne(offen) {
    zustand.offen = offen;
    wurzel.classList.toggle('cbchat--offen', offen);
    start.setAttribute('aria-expanded', String(offen));
    document.body.classList.toggle('cbchat-offen', offen);
    document.body.classList.toggle('cbchat-gesperrt', offen && window.matchMedia('(max-width: 640px)').matches);
    speichere();
    if (offen) {
      zeichneAlles();
      setTimeout(function () { eingabe.focus({ preventScroll: true }); }, 50);
    } else {
      start.focus({ preventScroll: true });
    }
  }
  start.addEventListener('click', function () { oeffne(true); });
  wurzel.querySelector('[data-aktion="zu"]').addEventListener('click', function () { oeffne(false); });
  wurzel.querySelector('[data-aktion="neu"]').addEventListener('click', function () {
    if (laeuft) return;
    zustand.verlauf = [];
    zustand.id = neueId();
    zustand.bewertung = null;
    zustand.kommentiert = false;
    speichere();
    zeichneAlles();
    eingabe.focus();
  });
  wurzel.addEventListener('keydown', function (e) { if (e.key === 'Escape' && zustand.offen) oeffne(false); });

  // ── Eingabe ──
  function passeHoeheAn() {
    eingabe.style.height = 'auto';
    eingabe.style.height = Math.min(eingabe.scrollHeight, 120) + 'px';
    sendenBtn.disabled = laeuft || !eingabe.value.trim();
  }
  eingabe.addEventListener('input', passeHoeheAn);
  eingabe.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit')); }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = eingabe.value.trim();
    if (!t || laeuft) return;
    if (hoertZu && erkennung) erkennung.abort();
    eingabe.value = '';
    passeHoeheAn();
    sende(t);
  });

  // ── Spracheingabe (Spracherkennung des Browsers: Chrome/Edge → Google, Safari → Apple) ──
  // Der erkannte Text landet im Eingabefeld und wird erst mit „Senden“ verschickt.
  var Erkennung = window.SpeechRecognition || window.webkitSpeechRecognition;
  var erkennung = null;
  var hoertZu = false;
  if (Erkennung && mikroBtn) {
    mikroBtn.hidden = false;
    var textVorher = '';
    var setzeMikro = function (an) {
      hoertZu = an;
      mikroBtn.classList.toggle('cbchat__mikro--an', an);
      mikroBtn.setAttribute('aria-label', an ? 'Spracheingabe beenden' : 'Spracheingabe starten');
      eingabe.placeholder = an ? 'Ich höre zu …' : 'Wonach suchst du?';
    };
    mikroBtn.addEventListener('click', function () {
      if (hoertZu && erkennung) { erkennung.stop(); return; }
      if (laeuft) return;
      erkennung = new Erkennung();
      erkennung.lang = 'de-DE';
      erkennung.interimResults = true;
      erkennung.continuous = false;
      textVorher = eingabe.value.trim();
      erkennung.onresult = function (ev) {
        var gesprochen = '';
        for (var i = 0; i < ev.results.length; i++) gesprochen += ev.results[i][0].transcript;
        eingabe.value = (textVorher ? textVorher + ' ' : '') + gesprochen.trim();
        passeHoeheAn();
      };
      erkennung.onerror = function (ev) {
        if (ev.error === 'not-allowed' || ev.error === 'service-not-allowed') {
          eingabe.placeholder = 'Mikrofon nicht erlaubt – bitte im Browser freigeben';
        }
      };
      erkennung.onend = function () { setzeMikro(false); eingabe.focus(); };
      try { erkennung.start(); setzeMikro(true); } catch (e) { setzeMikro(false); }
    });
  }

  // ── Senden + Antwort lesen (Server-Sent Events über fetch) ──
  function sende(text) {
    if (laeuft) return;
    if (!zustand.offen) oeffne(true);
    laeuft = true;
    sendenBtn.disabled = true;
    var chips = verlaufEl.querySelector('.cbchat__chips');
    if (chips) chips.remove();
    var bewertung = verlaufEl.querySelector('.cbchat__bewertung');
    if (bewertung) bewertung.remove();

    zustand.verlauf.push({ rolle: 'user', text: text });
    speichere();
    verlaufEl.appendChild(el('div', 'cbchat__msg cbchat__msg--user', text));

    // text/karten: für den Verlauf an den Server; teile: für die Darstellung
    var antwort = { rolle: 'assistant', text: '', karten: [], teile: [] };
    var aktuell = null; // { teil, el } des Textteils, in den gerade gestreamt wird
    var status = el('div', 'cbchat__status');
    status.innerHTML = '<span class="cbchat__punkte"><i></i><i></i><i></i></span><span>Denke nach …</span>';
    verlaufEl.appendChild(status);
    nachUnten();

    var anServer = zustand.verlauf.slice(0, -1).concat([{ rolle: 'user', text: text }]).map(function (e) {
      return { rolle: e.rolle, text: e.text || '', karten: (e.karten || []).map(function (k) { return { id: k.id, titel: k.titel }; }) };
    });

    function vorStatus(knoten) { verlaufEl.insertBefore(knoten, status.isConnected ? status : null); }
    function schreibe(stueck, fehler) {
      if (!aktuell) {
        var teil = { text: '' };
        antwort.teile.push(teil);
        aktuell = { teil: teil, el: el('div', 'cbchat__msg cbchat__msg--bot') };
        vorStatus(aktuell.el);
      }
      aktuell.teil.text += stueck;
      antwort.text += stueck;
      if (fehler) { aktuell.teil.fehler = true; aktuell.el.classList.add('cbchat__msg--fehler'); }
      aktuell.el.innerHTML = formatiere(aktuell.teil.text);
    }
    function ende() {
      if (status.isConnected) status.remove();
      if (antwort.text.trim() || antwort.karten.length) {
        zustand.verlauf.push(antwort);
        speichere();
      }
      laeuft = false;
      zeigeBewertung();
      passeHoeheAn();
      nachUnten();
    }
    function fehler(t) {
      if (status.isConnected) status.remove();
      verlaufEl.appendChild(botNachricht({ text: t, fehler: true }));
      laeuft = false;
      passeHoeheAn();
      nachUnten();
    }

    fetch(ENDPOINT + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        verlauf: anServer,
        seite: Object.assign({ url: location.pathname }, seite || {}),
        gespraech: zustand.id,
        geraet: window.matchMedia('(max-width: 768px)').matches ? 'mobil' : 'desktop'
      })
    }).then(function (res) {
      if (res.status === 429) throw new Error('Zu viele Anfragen. Bitte warte einen Moment.');
      if (!res.ok || !res.body) throw new Error('Clever Guide ist gerade nicht erreichbar. Bitte versuch es später noch einmal.');
      var reader = res.body.getReader();
      var dec = new TextDecoder();
      var puffer = '';
      function lies() {
        return reader.read().then(function (r) {
          if (r.done) { ende(); return; }
          puffer += dec.decode(r.value, { stream: true });
          var teile = puffer.split('\n\n');
          puffer = teile.pop();
          teile.forEach(function (block) {
            var ev = 'message', daten = '';
            block.split('\n').forEach(function (z) {
              if (z.indexOf('event: ') === 0) ev = z.slice(7);
              else if (z.indexOf('data: ') === 0) daten += z.slice(6);
            });
            var d = {};
            try { d = JSON.parse(daten || '{}'); } catch (e) { return; }
            if (ev === 'text') {
              schreibe(d.t || '');
            } else if (ev === 'status') {
              status.lastChild.textContent = d.s || 'Einen Moment …';
            } else if (ev === 'karten' && d.karten) {
              antwort.karten = antwort.karten.concat(d.karten).slice(-6);
              antwort.teile.push({ karten: d.karten });
              vorStatus(karteListe(d.karten));
              if (antwort.text) antwort.text += '\n\n';
              aktuell = null; // folgender Text erscheint unter den Karten
            } else if (ev === 'fehler') {
              aktuell = null;
              schreibe((antwort.text ? '\n\n' : '') + (d.text || 'Da ist etwas schiefgelaufen.'), true);
            }
            nachUnten();
          });
          return lies();
        });
      }
      return lies();
    }).catch(function (err) {
      fehler(err && err.message && /[äöüÄÖÜß]| /.test(err.message) ? err.message : 'Clever Guide ist gerade nicht erreichbar. Bitte versuch es später noch einmal.');
    });
  }

  // ── Öffnen über Links: Menüpunkt „Clever Guide“ (Link /#bikefinder oder /#clever-guide) oder ?bikefinder in der URL ──
  // Nicht verwechseln mit mailto:bikefinder@… (Bike-Alarm): nur #bikefinder bzw. Parameter bikefinder.
  function istBikefinderLink(href) {
    return !!href && !/^mailto:/i.test(href) && /(#bikefinder$|#clever-guide$|[?&](bikefinder|clever-guide)(=|&|$))/i.test(href);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !istBikefinderLink(a.getAttribute('href'))) return;
    e.preventDefault();
    var menuZu = document.querySelector('[data-cb-mobile-drawer].is-open [data-cb-mobile-close]');
    if (menuZu) menuZu.click(); // Handy-Menü schließen
    oeffne(true);
  }, true);
  if (istBikefinderLink(location.hash) || istBikefinderLink(location.search)) {
    zustand.offen = true;
    try {
      var p = new URLSearchParams(location.search);
      p.delete('bikefinder'); p.delete('clever-guide');
      var q = p.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : ''));
    } catch (e) { /* egal */ }
  }

  if (zustand.offen) oeffne(true);
})();
